import http from '../../utils/http'

const fetchSegmentsUrl = '/segments'

export const fetchSegments = () =>
  http.get(fetchSegmentsUrl).then(res => res.data)
